import { Form } from '@unform/web';
import styled from 'styled-components';

import { ButtonConfirm } from '../../../../../components/ButtonConfirm';
import { InputText } from '../../../../../components/InputText';
import { Select } from '../../../../../components/Select';
import { colors, radius } from '../../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  @media (max-width: 1199px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const PageTitle = styled.h1`
  font-size: 40px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.02em;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 12px;
`;

export const Discard = styled.button`
  padding: 0 20px;
  height: 44px;

  background-color: transparent;
  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.outlineVariant};
  cursor: pointer;

  font-size: 13px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &:hover {
    color: ${colors.onSurface};
  }
`;

export const DeleteButton = styled(Discard)`
  border-color: ${colors.error}80;
  color: ${colors.error};

  &:hover {
    color: ${colors.error};
    border-color: ${colors.error};
  }
`;

export const Grid = styled.div`
  max-width: 720px;
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
`;

export const Card = styled.div`
  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.lg};
  padding: 32px;
  margin-bottom: 24px;

  & > * {
    margin-bottom: 16px;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const Input = styled(InputText)``;

export const SelectField = styled(Select)``;

export const ContainerInline = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  gap: 16px;

  @media (max-width: 1199px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ContainerCardsMuscleGroups = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
`;

export const SidebarTitle = styled.h3`
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurfaceVariant};
`;

export const Submit = styled(ButtonConfirm)`
  align-self: flex-start;
  margin-top: 8px;
`;
